import React from "react";
import { Search } from "lucide-react";

export default function LearningArticleSearch({ value, onChange, placeholder = "Search articles...", label = "Search articles", isRtl = false }) {
  return (
    <label className="relative block w-full">
      <span className="sr-only">{label}</span>
      <Search
        className="pointer-events-none absolute top-1/2 h-5 w-5 -translate-y-1/2 text-[#168F92]"
        style={{ left: "1rem" }}
      />
      <input
        type="search"
        dir={isRtl ? "rtl" : "ltr"}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        style={{ textAlign: isRtl ? "right" : "left" }}
        className={`h-12 w-full rounded-2xl border border-[#BFDADC] bg-white/92 text-sm font-bold text-[#081633] shadow-sm outline-none transition placeholder:text-[#10233E]/45 focus:border-[#17A6A4] focus:ring-4 focus:ring-[#17A6A4]/10 ${isRtl ? "pl-12 pr-4" : "pl-12 pr-4"}`}
      />
    </label>
  );
}